import React, { useEffect, useRef, useState } from 'react';
import { TextField } from '@mui/material';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { PROFIL, REQUEST_PASS_TYPE } from '../../../constants/enum';
import ControlledTextField from '../../Controlled/RequestPass/ControlledTextField';
import { updateCaracConvoi, updateInfosCompl } from '../../../actions/RequestPassAction';
import { useDispatch } from 'react-redux';


export const StepInformationsComplementaires = (props) => {
  const {
    refs,
    profil,
    trajetDescr,
    complInfo,
    validation,
    setValidation,
    demandePassageStyle,
    handleChangeDate,
    validSteps,
    setValidSteps,
  } = props;

  const style = {
    row: {
      height: 'fit-content',
      alignItems: 'flex-start',
    },
    subRow: {
      display: 'flex',
      alignItems: 'center',
    },
    subRowLabel: {
      fontSize: '18px',
      textTransform: 'uppercase',
      color: '#33a9d5',
    },
  };

  const dispatch = useDispatch();
  const editable = validSteps.step8 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT);

  const handleCenterCommentInputChange = (value, index) => {
    let refCtrs = [...complInfo.refCtr];
    refCtrs[index].comment = value;
    handleChange('refCtr', refCtrs);
  };

  const handleChange = (name, value) => {
    dispatch(updateInfosCompl(name, value));
  };

  return (
    <div ref={(divRef) => refs.current['step-informations_complementaires'] = divRef} className='step'>
      <div className='step-content'>
        <div className='step-content-row'>
          <h3 className='modal-step-title'>Informations complémentaires</h3>

          {/* region Service TE */}
          <div className='row' style={{ ...style.row, justifyContent: 'space-between' }}>
            <div style={{
              ...style.subRow,
              justifyContent: 'space-between',
              width: '40%',
              marginLeft: '30px',
            }}>
              <div style={style.subRowLabel}>Service TE</div>
              <div style={style.subRow}>
                <div style={style.subRowLabel}>DDT</div>
                <DatePicker
                  label="Date de l'arrêté"
                  name='dateArrete'
                  value={complInfo.dateArrete || null}
                  style={demandePassageStyle.textField}
                  onChange={(newValue) => handleChange('dateArrete', newValue)}
                  renderInput={(params) => <TextField {...params} />}
                  inputVariant='outlined'
                  disabled={editable}
                />
              </div>
            </div>
            <div style={{
              marginLeft: "auto"
            }}>
              {/* region DESC1 */}
              <div style={style.subRow}>
                <div style={style.subRowLabel}>DESC</div>
                <ControlledTextField
                  label='N° arrêté'
                  type='text'
                  name='desc1Number'
                  value={complInfo.desc1Number || ''}
                  style={{ maxWidth: '15%', margin: '20px' }}
                  autoComplete='off'
                  fullWidth={false}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  inputProps={{ maxLength: 25 }}
                  disabled={editable}
                />
                <DatePicker
                  label='Date'
                  name='dateArrete'
                  value={complInfo.desc1Date || null}
                  style={demandePassageStyle.textField}
                  onChange={(newValue) => handleChange('desc1Date', newValue)}
                  renderInput={(params) => <TextField {...params} />}
                  inputVariant='outlined'
                  disabled={editable}
                />
                <ControlledTextField
                    label='Libellé'
                    type='text'
                    name='desc1Label'
                    value={complInfo.desc1Label || ''}
                    style={{ width: '34%', margin: '20px' }}
                    autoComplete='off'
                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                    inputProps={{ maxLength: 255 }}
                    disabled={editable}
                />
              </div>
              {/* endregion */}
              {/* region DESC2 */}
              <div style={style.subRow}>
                <div style={style.subRowLabel}>DESC</div>
                <ControlledTextField
                  label='N° arrêté'
                  type='text'
                  name='desc2Number'
                  value={complInfo.desc2Number || ''}
                  style={{ maxWidth: '15%', margin: '20px' }}
                  autoComplete='off'
                  fullWidth={false}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  inputProps={{ maxLength: 25 }}
                  disabled={editable}
                />
                <DatePicker
                  label='Date'
                  name='dateArrete'
                  value={complInfo.desc2Date || null}
                  style={demandePassageStyle.textField}
                  onChange={(newValue) => handleChange('desc2Date', newValue)}
                  renderInput={(params) => <TextField {...params} />}
                  inputVariant='outlined'
                  disabled={editable}
                />
                <ControlledTextField
                  label='Libellé'
                  type='text'
                  name='desc2Label'
                  value={complInfo.desc2Label || ''}
                  style={{ width: '34%', margin: '20px' }}
                  autoComplete='off'
                  fullWidth={false}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  inputProps={{ maxLength: 255 }}
                  disabled={editable}
                />
              </div>
              {/* endregion */}
            </div>
          </div>

          <div className='row' style={style.row}>
            <div></div>
            <div style={{ ...style.subRow, width: '56%', marginLeft: '24px' }}>
              <div>Horaires de passage: de</div>
              <TimePicker
                label='Heure'
                name='horPassDebut'
                value={complInfo.horPassDebut || null}
                style={demandePassageStyle.textField}
                onChange={(newValue) => handleChange('horPassDebut', newValue)}
                renderInput={(params) => <TextField {...params} />}
                inputVariant='outlined'
                disabled={editable}
              />
              <div> à</div>
              <TimePicker
                label='Heure'
                name='horPassFin'
                value={complInfo.horPassFin || null}
                style={demandePassageStyle.textField}
                onChange={(newValue) => handleChange('horPassFin', newValue)}
                renderInput={(params) => <TextField {...params} />}
                inputVariant='outlined'
                disabled={editable}
              />
            </div>
          </div>

          <div className='row' style={style.row}>
            <div></div>
            <div style={{ ...style.subRow, width: '56%', marginLeft: '24px' }}>
              Complément d'information: (affiché sur le DEVIS, l'ACCORD DE PRINCIPE et l'ACCORD DE PASSAGE)
            </div>
          </div>

          <div className='row' style={style.row}>
            <div></div>
            <div style={{ ...style.subRow, width: '79%', marginLeft: 'auto' }}>
              <ControlledTextField
                label=''
                type='text'
                name='servTeInfo'
                value={complInfo.servTeInfo || ''}
                style={{ margin: '20px' }}
                autoComplete='off'
                fullWidth={true}
                multiline
                rows={4}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                inputProps={{ maxLength: 1000 }}
                disabled={editable}
              />
            </div>
          </div>

          {/* endregion */}

          {/* region Service OA */}
          <div className='row' style={{ ...style.row, justifyContent: 'space-between' }}>
            <div style={{
              ...style.subRow,
              justifyContent: 'space-between',
              width: '100%',
              marginLeft: '30px',
            }}>
              <div style={style.subRowLabel}>Service OA</div>
              <div style={{ ...style.subRow, width: '79%', marginLeft: '24px' }}>
                Prescriptions spécifiques : (affichées sur le DEVIS, l'ACCORD DE PRINCIPE et l'ACCORD DE PASSAGE)
              </div>
            </div>
          </div>

          <div className='row' style={style.row}>
            <div></div>
            <div style={{ ...style.subRow, width: '79%', marginLeft: 'auto' }}>
              <ControlledTextField
                label=''
                type='text'
                name='servOaInfo'
                value={complInfo.servOaInfo || ''}
                style={{ margin: '20px' }}
                autoComplete='off'
                fullWidth={true}
                multiline
                rows={4}
                onChange={(e) => handleChange(e.target.name, e.target.value)}
                inputProps={{ maxLength: 1000 }}
                disabled={editable}
              />
            </div>
          </div>
          {/* endregion */}

          {/* region Référents des centres */}
          <div className='row' style={{ ...style.row, justifyContent: 'space-between' }}>
            <div style={{
              ...style.subRow,
              justifyContent: 'space-between',
              width: '100%',
              marginLeft: '30px',
            }}>
              <div style={style.subRowLabel}>Référents des centres</div>
              <div style={{ ...style.subRow, width: '79%', marginLeft: '24px' }}>
                Prescriptions spécifiques : (affichées sur le DEVIS et l'ACCORD DE PRINCIPE)
              </div>
            </div>
          </div>

          <div className='row' style={{ ...style.row, justifyContent: 'space-between' }}>
            <div style={{
              ...style.subRow,
              justifyContent: 'space-between',
              width: '100%',
              marginLeft: '30px',
            }}>
              <div>(complété pour chaque centre)</div>
              <div style={style.subRow}></div>
            </div>
          </div>

          <div className='row' style={{ ...style.row, justifyContent: 'space-between' }}>
            <div style={{
              ...style.subRow,
              justifyContent: 'space-between',
              width: '100%',
              marginLeft: '30px',
            }}>
              <div style={{ ...style.subRow, marginLeft: "auto", display:"flex", flexDirection:"column", width: "78%", marginRight:"20px", marginTop:"-15px" }}>
                {complInfo.refCtr.map((ctr, index) => (
                  <ControlledTextField
                    key={"refCtr_" + index}
                    label={ctr.name}
                    type='text'
                    name='comment'
                    value={ctr.comment || ''}
                    style={{ margin: '20px' }}
                    autoComplete='off'
                    fullWidth={true}
                    multiline
                    rows={4}
                    onChange={(e) => handleCenterCommentInputChange(e.target.value, index)}
                    inputProps={{ maxLength: 400 }}
                    disabled={editable}
                  />
                ))}
              </div>
            </div>
          </div>
          {/*  endregion */}

        </div>
      </div>
    </div>
  );
};